$(function () {

    var _parts = null;
    var _users = null;

    void 0;
    /* HELPERS JAVASCRIPT*/
    function exists(selector) {
        return $(selector).length > 0 ? true : false;
    }

    function capturaUrl() {
        var url = window.location.href;
        var pos = url.lastIndexOf("/");
        var section = url.substring(pos + 1);
        return section
    }

    //**Atualizar Scrool da lista/
    if (exists($(".item_list_body"))) {
        $body = $(".item_list_body");
        var lista = $body.find('li');
        var achei = false;
        var tamanho = lista.length;
        //console.log(tamanho);
        lista.each(function (index, element) {
            var sub_list = $(element).find('.item_list_sub_group p');
            if (sub_list instanceof Array) {
                if (!achei) {
                    void 0;
                    $body.scrollTop((index + 1) * 30);
                }
                if (sub_list[2].innerHTML == capturaUrl()) {
                    achei = true;
                }
            }
        });
    }

    /*****************
     *  SERVICE DESIGNATION
     *****************/

    $("#new-desgination").on("click", function (e) {
        e.preventDefault();
        void 0;

        var $div = $("<div></div>");
        $div.addClass("multiple_item designation");

        var input_1 = $("<input>");
        var input_2 = $("<input>");
        var input_3 = $("<input>");
        var input_4 = $("<input>");
        var input_5 = $("<input>");

        input_1.attr({'type': 'number', 'name': 'assignment[]','min':1,'max':100});
        input_2.attr({'type': 'text', 'name': 'type[]'});
        input_3.attr({'type': 'text', 'name': 'symptom[]'});
        input_4.attr({'type': 'text', 'name': 'error[]'});
        input_5.attr({'type': 'text', 'name': 'action[]'});


        var $div_icon = $("<div></div>");
        $div_icon.addClass("icon-delete flex-6");

        var img = $("<img>");
        img.attr({
            'src': '../themes/version_1/assets/images/icons/system/ic_highlight_off_black_18dp.png'
        });

        $div_icon.on("click", function () {
            $div.remove();
        });

        $div_icon.append(img);
        $div.append(input_1, input_2, input_3, input_4, input_5, $div_icon);

        $(".list_new_designation").append($div);

    });

    // ENVIO DE DADOS PARA EXCLUSAO VIA AJAX
    $("[data-post]").on("click", function (e) {
        e.preventDefault();
        var clicked = $(this);
        var dataset = clicked.data();
        var load = $(".float_modal");
        var flashClass = "ajax_response";
        var flash = $("." + flashClass);

        $.ajax({
            method: 'post',
            url: clicked.data("post"),
            data: dataset,
            dataType: "json",
            crossDomain: true,
            beforeSend: function () {
                void 0;
            },
            success: function (response) {
                void 0;
                void 0;

                if (response.redirect) {
                    window.location.href = response.redirect;
                }
                //message
                if (response.message) {
                    void 0;
                    if (flash.length) {
                        flash.html(response.message).fadeIn(100);
                    }
                } else {
                    flash.fadeOut(100);
                }
                if (response.status) {
                    clicked.parent().fadeOut('fast', function () {
                        clicked.parent().remove();
                    })

                }
            },
        }).fail(function (exc) {
            void 0;
            void 0;
        });
    });


    /*****************
     *  SERVICE PARTS
     *****************/

    $("#new-parts").on("click", function (e) {
        e.preventDefault();
        void 0;

        var $div = $("<div></div>");
        $div.addClass("multiple_item parts");

        var select_id = $("<select></select>");
        var option = $("<option></option>");
        var select_desc = $("<select></select>");
        var input_3 = $("<input>");

        select_id.attr({'name': 'parts_id[]'});
        option.attr({'value': '0'}).text("Aguarde...");
        select_id.append(option);

        select_desc.attr({'name': 'parts_description[]'});
        select_desc.append(option.clone());

        input_3.attr({'type': 'number', 'name': 'parts_quantity[]'});

        var $div_icon = $("<div></div>");
        $div_icon.addClass("icon-delete flex-4");

        var img = $("<img>");
        img.attr({
            'src': '../themes/version_1/assets/images/icons/system/ic_highlight_off_black_18dp.png'
        });

        $div_icon.on("click", function () {
            $div.remove();
        });

        $div_icon.append(img);
        $div.append(select_id, select_desc, input_3, $div_icon);

        select_id.on('change',function () {
            atualizaSelectParts($(this).val());
        })

        select_desc.on('change',function () {
            atualizaSelectParts($(this).val());
        })

        $(".list_new_parts").append($div);

        if (_parts == null) {
            $.ajax({
                method: 'post',
                url: '../search/parts',
                data: "",
                dataType: "json",
                crossDomain: true,
                success: function (response) {
                    void 0;
                    void 0;
                    _parts = response.parts;
                    carregaDados();
                },
            }).fail(function (exc) {
                void 0;
            });
        } else {
            carregaDados();
        }

        function carregaDados(){
            select_id.html("");
            select_desc.html("");
            _parts.forEach(function (el, i) {
                void 0;
                var opt1 = $("<option></option>");
                var opt2 = $("<option></option>");
                opt1.attr({'value': el.id}).text(el.id);
                opt2.attr({'value': el.id}).text(el.description);

                select_id.append(opt1);
                select_desc.append(opt2);
            })
        }
        function atualizaSelectParts($id){
            void 0;
            select_id.val($id);
            select_desc.val($id);
        }

    });


    /*****************
     *  SERVICE HOURS
     *****************/

    $("#new-hours").on("click", function (e) {
        e.preventDefault();
        void 0;

        var $div = $("<div></div>");
        $div.addClass("multiple_item hours");

        var select_user = $("<select></select>");
        var option = $("<option></option>");

        var input_2 = $("<input>");
        var input_3 = $("<input>");
        var input_4 = $("<input>");

        select_user.attr({'name': 'id_user[]'});
        option.attr({'value': '0'}).text("Aguarde...");
        select_user.append(option);

        input_2.attr({'type': 'time', 'name': 'start[]'});
        input_3.attr({'type': 'time', 'name': 'end[]'});
        input_4.attr({'type': 'text', 'name': 'time[]','disabled':true});


        var $div_icon = $("<div></div>");
        $div_icon.addClass("icon-delete flex-5");

        var img = $("<img>");
        img.attr({
            'src': '../themes/version_1/assets/images/icons/system/ic_highlight_off_black_18dp.png'
        });

        $div_icon.on("click", function () {
            $div.remove();
        });

        $div_icon.append(img);
        $div.append(select_user, input_2, input_3, input_4, $div_icon);

        $(".list_new_hours").append($div);
        if (_users == null) {
            $.ajax({
                method: 'post',
                url: '../search/users',
                data: "",
                dataType: "json",
                crossDomain: true,
                success: function (response) {
                    void 0;
                    void 0;
                    _users = response.users;
                    carregaDados();
                },
            }).fail(function (exc) {
                void 0;
            });
        } else {
            carregaDados();
        }

        function carregaDados(){
            select_user.html("");
            _users.forEach(function (el, i) {
                void 0;
                if(el.id_type_user != '1') {
                    var opt1 = $("<option></option>");
                    opt1.attr({'value': el.id}).text(el.name);
                    select_user.append(opt1);
                }
            })
        }
    });


     /*
        START/REMOVE LOADING
      */
    $(".report a:not('.loading-off')").on("click", function () {
        $(".float_modal").removeClass('none');
    });
    $(".btn_float").on("click", function () {
        $(".float_modal").removeClass('none');
    });
    $(".item_list_body:not('.loading-off') ul li").on("click", function () {
        $(".float_modal").removeClass('none');
    });
    $(".report-item a:not('.loading-off')").on("click", function () {
        $(".float_modal").removeClass('none');
    });
    $("#cancel").on("click", function () {
        $(".float_modal").removeClass('none');
    });
    if (!$(".float_modal").hasClass('none')) {
        $(".float_modal").addClass('none');
    }
    $("menu ul li").on("click", function () {
        $(".float_modal").removeClass('none');
    });


    //* IMPRESSÃO*/

    $(".print").on("click", function () {
        window.print();
    });

    /*
         FILTER
     */
    $("[data-filter]").keyup(function () {
         //console.log($(this).val());
         filter($(this).val());
    })

    function filter($text){
        var list = $(".item_list_body").find('li');
        if($text == "") {
            $(".item_list_body").find('li').css('display', 'block');
        }else{
            $(".item_list_body").find('li').css('display', 'none');
        }
        if(list instanceof Object){
            list.each(function(ind,el){
                $p = $(el).find(".content_item_list p:not(.filter-off)");
                $p.each(function (ind2,el2) {
                    if((el2.innerHTML.length) > 0) {
                        var aux = removeAccent(el2.innerHTML);
                        //console.log(aux + " tem " + $text.toUpperCase() + " => "+ aux.indexOf($text.toUpperCase()));
                        if (aux.indexOf(removeAccent($text)) >= 0) {
                            $(el).css('display','block');
                        }
                    }
                 })
            })
        }
    }

    function removeAccent (text)
    {
        text = text.toUpperCase();
        text = text.replace(new RegExp('[ÁÀÂÃ]','gi'), 'A');
        text = text.replace(new RegExp('[ÉÈÊ]','gi'), 'E');
        text = text.replace(new RegExp('[ÍÌÎ]','gi'), 'I');
        text = text.replace(new RegExp('[ÓÒÔÕ]','gi'), 'O');
        text = text.replace(new RegExp('[ÚÙÛ]','gi'), 'U');
        text = text.replace(new RegExp('[Ç]','gi'), 'C');
        return text;
    }

    $("[data-generate]").on('click',function () {
        $code = Math.random().toString(36).substr(2, 9);
        $('[data-code]').val($code.toUpperCase());
    })


    /* Mostra Menu */
    $(".select_menu_hamburg").on("click", function (e) {
        e.preventDefault();
        $("header .menu").fadeIn("fast");
    });

    /* Esconde Menu */
    $("#action-back").on("click", function (e) {
        e.preventDefault();
        $("header .menu").fadeOut("fast");
    })


    /*Resetar Senha*/
    $("#reset-senha").on("click", function (e) {
        $(this).toggleClass("none");
        $(".profile_group_password").toggleClass("none");
    });


    /* Remove mensagem */
    $(".trigger span").on("click", function (e) {
        $(this).parent().fadeOut("fast", function () {
            $(this).remove();
        })
    })

    if(exists($('[data-filter]'))){
        $selector = $('[data-filter]');
        if($selector.val().length > 0){
            filter($selector.val());
        }
    }

    $("form:not('.ajax_off')").submit(function (e) {
        e.preventDefault();
        var form = $(this);
        var load = $(".float_modal");
        var flashClass = "ajax_response";
        var flash = $("." + flashClass);

        form.ajaxSubmit({
            url: form.attr("action"),
            type: "POST",
            dataType: "json",
            beforeSend: function () {
                void 0;
                load.removeClass('none');
            },
            success: function (response) {
                void 0;
                void 0;
                //redirect
                if (response.redirect) {
                    window.location.href = response.redirect;
                }

                //message
                if (response.message) {
                    if (flash.length) {
                        flash.html(response.message).fadeIn(100);
                    }
                } else {
                    flash.fadeOut(100);
                }
            },
            complete: function () {
                void 0;
                load.addClass('none');

                if (form.data("reset") === true) {
                    form.trigger("reset");
                }
            },
            error: function (event) {
                //console.log(event);
            }
        });
    })
});